import { defineStore } from 'pinia';

export const useClipboardStore = defineStore('clipboard', {
  state: () => ({
    elements: []
  }),
  actions: {
    copy(elements) {
      const items = Array.isArray(elements) ? elements : [elements];
      if (!items.every(el => el && typeof el === 'object')) {
        throw new Error('Only objects can be copied');
      }
      this.elements = items;
    },
    paste() {
      return [...this.elements];
    }
  }
});
